module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-button-group', [_c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "plus"
    },
    on: {
      "click": function($event) {
        _vm.createBackup()
      }
    }
  }, [_vm._v("Commit")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.getBackups()
      }
    }
  }, [_vm._v("Refresh")])], 1), _vm._v(" "), _c('el-table', {
    attrs: {
      "data": _vm.backups
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "ID"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "size",
      "label": "Size",
      "formatter": _vm.byte2Size,
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "createTime",
      "label": "Time",
      "sortable": "",
      "formatter": _vm.parseTime
    }
  }), _vm._v(" "), _c('el-table-column', {
    scopedSlots: _vm._u([
      ["default", function(scope) {
        return [_c('el-button-group', [_c('el-button', {
          attrs: {
            "type": "warning",
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.rollback(scope.row)
            }
          }
        }, [_vm._v("Rollback")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "danger",
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.deleteBackup(scope.row)
            }
          }
        }, [_vm._v("Delete")])], 1)]
      }]
    ])
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-6b129043"}!./~/.11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/nav/save/Backup.vue
// module id = 171
// module chunks = 1